import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAIConversationChatMessage } from './useAIConversationChatMessageQuery';

export function useAIConversationMessageFeedbackMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			conversationId,
			messageId,
			feedbackType,
			impersonationContext,
		}: {
			conversationId: string;
			messageId: string;
			feedbackType: Api.AIChatMessageFeedback;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.AIChatMessage>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aiconversation/${conversationId}/chatMessage/${messageId}/feedback`,
					impersonationContext,
				}),
				'PUT',
				feedbackType
			);
		},
		onError,
		onSuccess: (_, variables) => {
			// Invalidate the conversation messages query to refetch with updated feedback
			invalidateAIConversationChatMessage(variables.conversationId);
			onSuccess?.();
		},
	});
}
